import { render, staticRenderFns } from "./FButton.vue?vue&type=template&id=0cc09c17&scoped=true&"
import script from "./FButton.vue?vue&type=script&lang=js&"
export * from "./FButton.vue?vue&type=script&lang=js&"
import style0 from "./FButton.vue?vue&type=style&index=0&id=0cc09c17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc09c17",
  null
  
)

export default component.exports